import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Header = ({ language, setLanguage }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const translations = {
    tr: {
      contact: "İletişim:",
      phone: "+32 485 93 59 29",
      hours: "Açılış saatleri:",
      schedule: "Pazartesi-Cuma: 9:00-18:30, Cumartesi: 9:00-17:00",
      home: "Ana sayfa"
    },
    fr: {
      contact: "Contact:",
      phone: "+32 485 93 59 29",
      hours: "Horaires:",
      schedule: "Lun-Ven: 9h00-18h30, Sam: 9h00-17h00",
      home: "Accueil"
    },
    nl: {
      contact: "Contact:",
      phone: "+32 485 93 59 29", 
      hours: "Openingstijden:",
      schedule: "Ma-Vr: 9u00-18u30, Za: 9u00-17u00",
      home: "Home"
    }
  };

  const t = translations[language] || translations.tr;

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <header style={{ 
      position: 'sticky', 
      top: 0, 
      zIndex: 999999, 
      background: 'var(--primary-black)',
      boxShadow: '0 2px 20px rgba(0, 0, 0, 0.3)',
      width: '100%'
    }}>
      {/* Header Top - Hidden on small screens */}
      <div className="header-top d-none d-md-block" style={{
        background: 'var(--dark-black)',
        padding: '10px 0',
        width: '100%'
      }}>
        <div className="container-fluid" style={{ padding: '0 15px' }}>
          <div className="row align-items-center">
            <div className="col-md-8">
              <div className="welcome-msg">
                <div className="d-flex flex-wrap align-items-center">
                  <div className="contact-item me-4">
                    <i className="fas fa-phone text-danger me-2"></i>
                    <span style={{ color: 'var(--white)', fontSize: '14px' }}>
                      <strong>{t.contact}</strong> {t.phone}
                    </span>
                  </div>
                  <div className="contact-item">
                    <i className="fas fa-clock text-danger me-2"></i>
                    <span style={{ color: 'var(--gold-accent)', fontSize: '14px' }}>
                      {t.schedule}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="header-top-menu">
                <div className="d-flex justify-content-end align-items-center">
                  <a href="https://www.facebook.com/ozcanlar.ozcan.77/" 
                     className="me-3"
                     style={{ 
                       color: 'var(--primary-red)', 
                       fontSize: '18px',
                       transition: 'color 0.3s ease'
                     }}
                     onMouseOver={(e) => e.target.style.color = 'var(--gold-accent)'}
                     onMouseOut={(e) => e.target.style.color = 'var(--primary-red)'}
                  >
                    <i className="fab fa-facebook"></i>
                  </a>
                  <div className="language-switcher d-flex gap-2">
                    <button 
                      onClick={() => setLanguage('tr')}
                      style={{ 
                        border: 'none', 
                        background: 'none',
                        opacity: language === 'tr' ? 1 : 0.6,
                        transition: 'opacity 0.3s ease'
                      }}
                    >
                      <img width="25px" src="/img/turquie.png" alt="Türkçe" 
                           style={{ borderRadius: '3px' }} />
                    </button>
                    <button 
                      onClick={() => setLanguage('nl')}
                      style={{ 
                        border: 'none', 
                        background: 'none',
                        opacity: language === 'nl' ? 1 : 0.6,
                        transition: 'opacity 0.3s ease'
                      }}
                    >
                      <img width="25px" src="/img/belgique.png" alt="Nederlands" 
                           style={{ borderRadius: '3px' }} />
                    </button>
                    <button 
                      onClick={() => setLanguage('fr')}
                      style={{ 
                        border: 'none', 
                        background: 'none',
                        opacity: language === 'fr' ? 1 : 0.6,
                        transition: 'opacity 0.3s ease'
                      }}
                    >
                      <img width="25px" src="/img/france.png" alt="Français" 
                           style={{ borderRadius: '3px' }} />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Main Navigation */}
      <div className="main-navigation" style={{
        background: 'var(--primary-black)',
        padding: '15px 0',
        width: '100%'
      }}>
        <div className="container-fluid" style={{ padding: '0 15px' }}>
          <div className="row align-items-center">
            {/* Logo */}
            <div className="col-6 col-md-3">
              <div className="logo">
                <Link to="/" onClick={closeMobileMenu} style={{
                  display: 'flex',
                  alignItems: 'center',
                  textDecoration: 'none',
                  color: 'var(--white)'
                }}>
                  <span style={{
                    fontSize: '24px',
                    fontWeight: 'bold',
                    color: 'var(--white)',
                    textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)',
                    letterSpacing: '1px'
                  }}>
                    Garage Ozcanlar
                  </span>
                </Link>
              </div>
            </div>
            
            {/* Desktop Menu */}
            <div className="col-md-9 d-none d-md-block">
              <nav className="desktop-menu">
                <ul className="d-flex justify-content-end align-items-center mb-0 list-unstyled">
                  <li className="me-4">
                    <Link 
                      to="/" 
                      style={{
                        color: 'var(--white)',
                        textDecoration: 'none',
                        fontSize: '16px',
                        fontWeight: '500',
                        padding: '10px 20px',
                        borderRadius: '25px',
                        transition: 'all 0.3s ease',
                        border: '2px solid transparent'
                      }}
                      onMouseOver={(e) => {
                        e.target.style.background = 'var(--primary-red)';
                        e.target.style.borderColor = 'var(--gold-accent)';
                      }}
                      onMouseOut={(e) => {
                        e.target.style.background = 'transparent';
                        e.target.style.borderColor = 'transparent';
                      }}
                    >
                      <i className="fas fa-home me-2"></i>
                      {t.home}
                    </Link>
                  </li>
                  <li>
                    <a 
                      href={`tel:${t.phone}`}
                      style={{
                        background: 'linear-gradient(45deg, var(--primary-red), var(--dark-red))',
                        color: 'white',
                        textDecoration: 'none',
                        padding: '12px 25px',
                        borderRadius: '25px',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        border: '2px solid var(--gold-accent)',
                        transition: 'all 0.3s ease',
                        boxShadow: '0 4px 15px rgba(220, 38, 38, 0.3)'
                      }}
                      onMouseOver={(e) => {
                        e.target.style.transform = 'translateY(-2px)';
                        e.target.style.boxShadow = '0 6px 20px rgba(220, 38, 38, 0.5)';
                      }}
                      onMouseOut={(e) => {
                        e.target.style.transform = 'translateY(0)';
                        e.target.style.boxShadow = '0 4px 15px rgba(220, 38, 38, 0.3)';
                      }}
                    >
                      <i className="fas fa-phone me-2"></i>
                      {t.phone}
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
            
            {/* Mobile Menu Toggle */}
            <div className="col-6 d-md-none text-end">
              <button 
                className="mobile-menu-toggle"
                onClick={toggleMobileMenu}
                style={{
                  background: 'var(--primary-red)',
                  border: '2px solid var(--gold-accent)',
                  color: 'white',
                  padding: '10px 15px',
                  borderRadius: '8px',
                  fontSize: '18px',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease'
                }}
                onMouseOver={(e) => {
                  e.target.style.background = 'var(--dark-red)';
                  e.target.style.transform = 'scale(1.05)';
                }}
                onMouseOut={(e) => {
                  e.target.style.background = 'var(--primary-red)';
                  e.target.style.transform = 'scale(1)';
                }}
              >
                <i className={`fas ${mobileMenuOpen ? 'fa-times' : 'fa-bars'}`}></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <div 
        className={`mobile-menu d-md-none ${mobileMenuOpen ? 'show' : ''}`}
        style={{
          background: 'var(--dark-black)',
          position: 'fixed',
          top: '120px',
          left: 0,
          right: 0,
          width: '100%',
          transform: mobileMenuOpen ? 'translateY(0)' : 'translateY(-100%)',
          opacity: mobileMenuOpen ? 1 : 0,
          visibility: mobileMenuOpen ? 'visible' : 'hidden',
          transition: 'all 0.3s ease',
          boxShadow: '0 5px 20px rgba(0, 0, 0, 0.3)',
          zIndex: 99999999
        }}
      >
        <div className="container-fluid" style={{ padding: '0 15px' }}>
          <div className="mobile-menu-content" style={{ padding: '20px 0' }}>
            {/* Contact Info on Mobile */}
            <div className="mobile-contact" style={{ 
              marginBottom: '20px',
              padding: '15px',
              background: 'var(--primary-black)',
              borderRadius: '10px',
              border: '1px solid var(--grey-dark)'
            }}>
              <div className="mb-2">
                <i className="fas fa-phone text-danger me-2"></i>
                <span style={{ color: 'var(--white)', fontSize: '14px' }}>
                  <strong>{t.contact}</strong> {t.phone}
                </span>
              </div>
              <div>
                <i className="fas fa-clock text-danger me-2"></i>
                <span style={{ color: 'var(--gold-accent)', fontSize: '12px' }}>
                  {t.schedule}
                </span>
              </div>
            </div>
            
            {/* Navigation Links */}
            <nav className="mobile-nav">
              <ul className="list-unstyled mb-0">
                <li style={{ marginBottom: '10px' }}>
                  <Link 
                    to="/" 
                    onClick={closeMobileMenu}
                    style={{
                      display: 'block',
                      color: 'var(--white)',
                      textDecoration: 'none',
                      padding: '15px 20px',
                      background: 'var(--primary-black)',
                      borderRadius: '8px',
                      border: '1px solid var(--grey-dark)',
                      fontSize: '16px',
                      fontWeight: '500',
                      transition: 'all 0.3s ease'
                    }}
                    onMouseOver={(e) => {
                      e.target.style.background = 'var(--primary-red)';
                      e.target.style.transform = 'translateX(10px)';
                    }}
                    onMouseOut={(e) => {
                      e.target.style.background = 'var(--primary-black)';
                      e.target.style.transform = 'translateX(0)';
                    }}
                  >
                    <i className="fas fa-home me-3"></i>
                    {t.home}
                  </Link>
                </li>
                <li style={{ marginBottom: '20px' }}>
                  <a 
                    href={`tel:${t.phone}`}
                    onClick={closeMobileMenu}
                    style={{
                      display: 'block',
                      background: 'linear-gradient(45deg, var(--primary-red), var(--dark-red))',
                      color: 'white',
                      textDecoration: 'none',
                      padding: '15px 20px',
                      borderRadius: '8px',
                      fontSize: '16px',
                      fontWeight: 'bold',
                      border: '2px solid var(--gold-accent)',
                      textAlign: 'center',
                      transition: 'all 0.3s ease'
                    }}
                    onMouseOver={(e) => {
                      e.target.style.transform = 'scale(1.02)';
                      e.target.style.boxShadow = '0 5px 15px rgba(220, 38, 38, 0.5)';
                    }}
                    onMouseOut={(e) => {
                      e.target.style.transform = 'scale(1)';
                      e.target.style.boxShadow = 'none';
                    }}
                  >
                    <i className="fas fa-phone me-3"></i>
                    {t.phone}
                  </a>
                </li>
              </ul>
            </nav>
            
            {/* Language Switcher & Social */}
            <div className="mobile-footer" style={{
              borderTop: '1px solid var(--grey-dark)',
              paddingTop: '15px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}>
              <div className="language-switcher d-flex gap-3">
                <button 
                  onClick={() => {setLanguage('tr'); closeMobileMenu();}}
                  style={{ 
                    border: 'none', 
                    background: 'none',
                    opacity: language === 'tr' ? 1 : 0.6,
                    transition: 'opacity 0.3s ease'
                  }}
                >
                  <img width="30px" src="/img/turquie.png" alt="Türkçe" 
                       style={{ borderRadius: '3px' }} />
                </button>
                <button 
                  onClick={() => {setLanguage('nl'); closeMobileMenu();}}
                  style={{ 
                    border: 'none', 
                    background: 'none',
                    opacity: language === 'nl' ? 1 : 0.6,
                    transition: 'opacity 0.3s ease'
                  }}
                >
                  <img width="30px" src="/img/belgique.png" alt="Nederlands" 
                       style={{ borderRadius: '3px' }} />
                </button>
                <button 
                  onClick={() => {setLanguage('fr'); closeMobileMenu();}}
                  style={{ 
                    border: 'none', 
                    background: 'none',
                    opacity: language === 'fr' ? 1 : 0.6,
                    transition: 'opacity 0.3s ease'
                  }}
                >
                  <img width="30px" src="/img/france.png" alt="Français" 
                       style={{ borderRadius: '3px' }} />
                </button>
              </div>
              <a href="https://www.facebook.com/ozcanlar.ozcan.77/" 
                 style={{ 
                   color: 'var(--primary-red)', 
                   fontSize: '24px',
                   transition: 'color 0.3s ease'
                 }}
                 onMouseOver={(e) => e.target.style.color = 'var(--gold-accent)'}
                 onMouseOut={(e) => e.target.style.color = 'var(--primary-red)'}
              >
                <i className="fab fa-facebook"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;